import { AlertDialog, renderReactDialog } from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { navigateToWorkspace } from "client/Features/Workspace/routing";

export type EmailNotConfiguredDialogProps = {
	hideConfigurationSuggestion?: boolean;
} & ({
	shouldNavigateBackToWorkspaceOnClose: true;
	onClose?(): void;
} | {
	shouldNavigateBackToWorkspaceOnClose: false;
	onClose(): void;
});

export const EmailNotConfiguredDialog = (props: EmailNotConfiguredDialogProps): ReactElement => {
	const {
		shouldNavigateBackToWorkspaceOnClose,
		onClose,
		hideConfigurationSuggestion = false
	} = props;

	const buttonText: string = shouldNavigateBackToWorkspaceOnClose
		? localize("_BackToWorkspace")
		: localize("_Close");

	const closeHandler = (): void => {
		onClose?.();
		if (shouldNavigateBackToWorkspaceOnClose) {
			navigateToWorkspace();
		}
	};

	return (
		<AlertDialog
			title={localize("_ExchangeIsNotConfigured")}
			confirmText={buttonText}
			onClose={closeHandler}
			trackingId="exchange-not-configured-dialog"
		>
			{!hideConfigurationSuggestion && (
				<>
					{localize("_YourAccountMayNotHaveAnExchangeMailboxInfo")}
				</>
			)}
		</AlertDialog>
	);
};
EmailNotConfiguredDialog.displayName="EmailNotConfiguredDialog";

export function showEmailNotConfiguredDialog(
	shouldNavigateBackToWorkspaceOnClose: boolean,
	hideConfigurationSuggestion?: boolean
): void {
	renderReactDialog((onClose) => (
		<EmailNotConfiguredDialog
			shouldNavigateBackToWorkspaceOnClose={shouldNavigateBackToWorkspaceOnClose}
			hideConfigurationSuggestion={hideConfigurationSuggestion}
			onClose={onClose}
		/>
	));
}